import {router} from '@inertiajs/react'
import {route} from 'ziggy-js'
import {rememberChatChannel} from '@/Library/Chat/chatPanelShell'

/** The chat page's Inertia component (`ChatController`). */
export const CHAT_PAGE_COMPONENT = 'Chat/Chat'

/** `/chat`, or `/chat/{channel}` for a channel (ENG-4740). */
export const chatPageUrl = (channelId: string | null): string =>
    channelId === null ? route('chat.index') : route('chat.show', {channel: channelId})

/** The docked panel's Expand: a visit to the page on the panel's channel. */
export const openChatPage = (channelId: string | null): void => {
    router.visit(chatPageUrl(channelId))
}

/**
 * The page's open channel: remembered for the docked panel to resume, and written to the address bar with a
 * client-side replace, so a reload or a copied link opens it without a visit per channel.
 */
export const showChatPageChannel = (channelId: string | null): void => {
    rememberChatChannel(channelId)
    const url = chatPageUrl(channelId)

    // The channel the page opened on is already in the address bar, perhaps with a query string kept as it is.
    if (new URL(url, window.location.href).pathname === window.location.pathname) {
        return
    }

    router.replace({
        url,
        props: props => ({...props, channelId}),
        preserveScroll: true,
        preserveState: true,
    })
}
